import React from 'react';
import { Group, Box } from '@mantine/core';
import { EventTypeFilter } from '../types';
import { EventTypeFilters } from './Calendar.event-type-filters';
import { RestaurantsSelect } from './Calendar.restaurants-select';

export const CalendarFilters: React.FC<{
  selectedEventType: EventTypeFilter[];
  onSelectEventType: (events: EventTypeFilter[]) => void;
  onSelectVendors: (vendors: string[]) => void;
  vendors: { name: string; id: string }[];
}> = ({ selectedEventType, onSelectEventType, onSelectVendors, vendors }) => {
  return (
    <Group grow>
      <RestaurantsSelect onSelectVendors={onSelectVendors} vendors={vendors} />
      <Group wrap="nowrap" maw="100%">
        {selectedEventType.map((event) => (
          <Box key={event.label}>
            <EventTypeFilters
              event={event}
              allEvents={selectedEventType}
              onChange={onSelectEventType}
            />
          </Box>
        ))}
      </Group>
    </Group>
  );
};

export default CalendarFilters;
